import React from 'react';
import Icon from '../../../components/AppIcon';

const RevenueCards = ({ dateRange }) => {
  const cards = [
    {
      title: 'Current Month Earnings',
      value: '$12,847.32',
      change: '+23.8%',
      changeType: 'positive',
      icon: 'DollarSign',
      color: 'primary'
    },
    {
      title: 'Total Plays',
      value: '45,921',
      change: '+12.5%',
      changeType: 'positive',
      icon: 'Play',
      color: 'secondary'
    },
    {
      title: 'Average Session Time',
      value: '8m 32s',
      change: '+5.2%',
      changeType: 'positive',
      icon: 'Clock',
      color: 'accent'
    },
    {
      title: 'Next Payout',
      value: 'Jan 25, 2025',
      change: '$10,234.56',
      changeType: 'neutral',
      icon: 'Calendar',
      color: 'muted'
    }
  ];

  const getChangeColor = (type) => {
    if (type === 'positive') return 'text-green-600';
    if (type === 'negative') return 'text-red-600';
    return 'text-muted-foreground';
  };

  const getChangeIcon = (type) => {
    if (type === 'positive') return 'TrendingUp';
    if (type === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
      {cards.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
              card.color === 'primary' ? 'bg-primary/10' :
              card.color === 'secondary' ? 'bg-secondary/10' :
              card.color === 'accent' ? 'bg-accent/10' : 'bg-muted/10'
            }`}>
              <Icon 
                name={card.icon} 
                size={24} 
                className={
                  card.color === 'primary' ? 'text-primary' :
                  card.color === 'secondary' ? 'text-secondary' :
                  card.color === 'accent' ? 'text-accent' : 'text-muted-foreground'
                }
              />
            </div>
            {card.change && (
              <div className={`flex items-center space-x-1 ${getChangeColor(card.changeType)}`}>
                <Icon name={getChangeIcon(card.changeType)} size={16} />
                <span className="text-sm font-medium">{card.change}</span>
              </div>
            )}
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">{card.value}</h3>
            <p className="text-sm text-muted-foreground">{card.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RevenueCards;